export { default as NLegacyTransfer, transferProps as legacyTransferProps } from './src/Transfer';
